import React from 'react'
import {connect} from 'react-redux'
import TabContent from '../../components/Shogun/TabContent'
import { receiveShogunData } from '../../actions/statusesActions'

const mapStateToProps = (state) => {
  return {
    shogunData: state.adminStatuses.shogun
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveShogunData: (data) => {
      dispatch(receiveShogunData(data))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(TabContent)


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/containers/Shogun/TabContentContainer.jsx